export default "__VITE_ASSET__DreEQG_A__"